import styled from '@emotion/styled'
import StepHeader, { StepHeaderProps } from './step.header'
import React from 'react'
import useStatus from 'modules/status/state/use-status'
import { StatusType } from 'modules/status/state/status-types'

interface StepRootProps {
  header?: StepHeaderProps
  children: React.ReactNode
}

export default function StepRoot({ header, children }: StepRootProps) {
  const status = useStatus()

  // Check if payment is being processed
  const isProcessing =
    status.type === StatusType.SUBMITTING || status.type === StatusType.PROCESSING

  return (
    <Root>
      {header && <StepHeader {...header} />}
      <Main>{children}</Main>
      {isProcessing && <ProcessingOverlay />}
    </Root>
  )
}

const Root = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
  position: relative;
`

const Main = styled.div`
  display: flex;
  flex-direction: column;
`

const ProcessingOverlay = styled.div`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  position: absolute;
  pointer-events: all;
`
